import React, { PropTypes } from 'react';

export default class PointLabelInput extends React.Component {

	constructor(props) {
		super(props);
		this.state = { animate: false };
	}

	render () {	
		const { name, value, index, action, disabled } = this.props;
		let _nome = (name || "Label");
		return (
								
			<div className='form-group'>
				{/* <label>{_nome}</label> */}
				<input 
					className='form-control'
					type="text"
					placeholder={_nome} 
					disabled={disabled}
					value={value||""}
					onChange={(e) => {
						action(e.target.value, index);
					}}>

				</input>
			</div>				
		);
	}
}

PointLabelInput.propTypes = {
	name: PropTypes.string,
	value: PropTypes.string,
	index: PropTypes.number.isRequired,
	action: PropTypes.func,
	disabled: PropTypes.bool
};




// WEBPACK FOOTER //
// ./src/components/Common/PointLabelInput.js